<template>
  <div>
    <label :for="this.id" class="font-weight-bold text-dark col-form-label form-control-label text-2">
      {{ this.label }}
    </label>
    <v-select v-model="selectedVal"
              :placeholder="this.label"
              :disabled="this.disabled"
              :clearable="this.clearable"
              :reduce="option => option.value"
              :options="this.options"
    />
    <input type="hidden" :name="this.name" v-model="selectedVal">
  </div>
</template>

<script>
  export default {
    name: "VueFormSelect",

    props: {
      id: {
        type: String,
        default: '',
      },
      name: {
        type: String,
        default: '',
      },
      label: {
        type: String,
        default: '',
      },
      value: {
        type: String,
        default: '',
      },
      clearable: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      hasError: {
        type: Boolean,
        default: false,
      },
      options: {
        type: Array,
        default: () => [],
      }
    },

    data() {
      return {
        selectedVal: this.value,
      }
    }
  }
</script>
